const calculatePercentage = (value: number, total: number): string => {
  if (total === 0) {
      throw new Error("Total cannot be zero");
  }

  const percentage = (value / total) * 100;
  const roundedPercentage = percentage.toFixed(1);

  return `${roundedPercentage}%`;
}

export default calculatePercentage;